import { render, staticRenderFns } from "./TDirectPayments.vue?vue&type=template&id=b72869fc&"
import script from "./TDirectPayments.vue?vue&type=script&lang=js&"
export * from "./TDirectPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72869fc')) {
      api.createRecord('b72869fc', component.options)
    } else {
      api.reload('b72869fc', component.options)
    }
    module.hot.accept("./TDirectPayments.vue?vue&type=template&id=b72869fc&", function () {
      api.rerender('b72869fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/capsules/TDirectPayments.vue"
export default component.exports